import { GeneralComponent } from "../General/g.component";

export abstract class CryptoView extends GeneralComponent {

    abstract getMapping();

    abstract setmapping(mapping: string);

    abstract resetmapping();

    abstract setHints(hints: string[]);
    
    abstract fillMapping();
}
